<script setup lang='ts'>
import { useCarBrand } from './hooks'
import { LOAD_STATE } from '~/shared/types'
import type { BrandResponse } from '@/server/types'
import { brandListApi, modelListApi, seriesListApi } from '@/server'

const props = withDefaults(defineProps<{
  brandId?: number
}>(), {})
const emits = defineEmits({
  select: (_data: BrandResponse) => true,
})

const {
  loadState,
  brandKeys,
  brandList,
  getBrandList,
} = useCarBrand()
async function initHandle() {
  await getBrandList()
}
function select(data: BrandResponse) {
  emits('select', data)
}

function indexClickHandler(e: Event) {
  const target = e.target as HTMLElement
  const key = target.textContent
  const el = document.querySelector(`#brand-${key}`)
  if (el)
    el.scrollIntoView()
}

initHandle()

const brandName = ref(undefined)
const brandSearchData = reactive({
  loading: false,
  options: [] as BrandResponse[],

})

async function getBrandFn(brandName: string) {
  const { data } = await brandListApi({ brandName })

  brandSearchData.options = Object.values(data).flat()
  // Array.flat(data)
}

const handleBrandSearch = useDebounceFn(query => getBrandFn(query), 200)
function handleUpdateValue(_v: string, brand: BrandResponse) {
  select(brand)
}
</script>

<template>
  <div class="car-container">
    <UtilLoadState :state="loadState" :reload-handler="initHandle">
      <div class="index-list" @click="indexClickHandler">
        <NScrollbar>
          <div v-for="key in brandKeys" :key="key" class="index-item">
            {{ key }}
          </div>
        </NScrollbar>
      </div>

      <div class="car-list">
        <div class="p-3">
          <n-select
            v-model:value="brandName"
            filterable
            placeholder="请搜索品牌"
            :options="brandSearchData.options"
            :loading="brandSearchData.loading"
            clearable
            remote
            label-field="brandName"
            value-field="id"
            @search="handleBrandSearch"
            @update:value="handleUpdateValue"
          />
        </div>
        <div v-for="key in brandKeys" :id="`brand-${key}`" :key="key">
          <div class="car-key">
            {{ key }}
          </div>
          <div v-if="brandList.get(key) && brandList.get(key)?.length" class="flex flex-wrap p-3">
            <div
              v-for="brand in brandList.get(key)" :key="brand.id"
              class="car-item"
              :class="{ active: brand.id === props.brandId }"
              @click="select(brand)"
            >
              {{ brand.brandName }}
            </div>
          </div>
        </div>
      </div>
    </UtilLoadState>
  </div>
</template>

<style lang="scss" scoped>
@import './index.scss';
</style>
